import React from "react";
import style from '../home/testimonial.css'
import maleImage from '../../assets/images/female.png'

function ClientReview() {
  return (
    <section id="main_sec mb-4">
      <div className="container">
        <h1 className="section__header">
        Mentees & Mentors Love it{" "}
          {/* <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</span> */}
        </h1>
        <div className="testimonials_review">
          <div
            id="carouselExampleControls"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="single__item">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="profile_review">
                        <div className="img__area">
                          <img className="img-fluid" src={maleImage} alt="" />
                        </div>
                        <div className="bio">
                          <h2>Bheem Kumar</h2>
                          <h4>Web Developer</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="review_content">
                        <p>
                          <center><h4>Mentor</h4></center>
                          <span>
                            <i className="fa fa-quote-left" />
                          </span>

                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit. Vel a eius excepturi molestias commodi aliquam
                          error magnam consectetur laboriosam numquam, minima
                          eveniet nostrum sequi saepe ipsam non ea, inventore
                          tenetur! Corporis commodi consequatur molestiae
                          voluptatum!
                        </p>
                        <center className="socials">
                        <i className="fa fa-twitter" />
                        <i className="fa fa-linkedin" />
                        <i className="fa fa-pinterest" />
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="single__item">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="profile_review">
                        <div className="img__area">
                          <img src={maleImage} alt="" />
                        </div>
                        <div className="bio">
                          <h2>Raj Kumar</h2>
                          <h4>UI/UX Designer</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="review_content">
                        <p>
                        <center><h4>Mentee</h4></center>

                          <span>
                            <i className="fa fa-quote-left" />
                          </span>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit. Vel a eius excepturi molestias commodi aliquam
                          error magnam consectetur laboriosam numquam, minima
                          eveniet nostrum sequi saepe ipsam non ea, inventore
                          tenetur! Corporis commodi consequatur molestiae
                          voluptatum!
                        </p>
                        <center className="socials">
                        <i className="fa fa-twitter" />
                        <i className="fa fa-linkedin" />
                        <i className="fa fa-pinterest" />
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
              <div className="single__item">
                <div className="row">
                  <div className="col-md-5">
                    <div className="profile_review">
                      <div className="img__area">
                        <img src={maleImage} alt="" />
                      </div>
                      <div className="bio">
                        <h2>Sonu Kumar</h2>
                        <h4>Content Writer</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="review_content">
                      <p>
                      <center><h4>Mentor</h4></center>

                        <span>
                          <i className="fa fa-quote-left" />
                        </span>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Vel a eius excepturi molestias commodi aliquam
                        error magnam consectetur laboriosam numquam, minima
                        eveniet nostrum sequi saepe ipsam non ea, inventore
                        tenetur! Corporis commodi consequatur molestiae
                        voluptatum!
                      </p>
                      <center className="socials">
                        <i className="fa fa-twitter" />
                        <i className="fa fa-linkedin" />
                        <i className="fa fa-pinterest" />
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  </section>
  )
}
export default ClientReview;